import { AnimatePresence, motion } from "framer-motion"
import { defaultTransition } from "./common"

export const HorizontalGradient = ({ done, x = 0 }) => {
    return (
        <AnimatePresence mode="wait">
            <motion.div
                initial={{ x: x, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: -x, opacity: 0 }}
                transition={{ delay: 1.5, duration: 1, }}
                className={`bg-gradient-to-r w-full h-[2px] ${done ? "from-success/0 via-success to-success/0" : "from-warn/0 via-warn to-warn/0"}`}
            />
        </AnimatePresence>
    )
}